<template lang="pug">
  #app
    router-view(name="header")
    router-view(name="content")
    router-view(name="footer")
</template>

<script>
const config = require('../config')
const subdirectory = process.env.NODE_ENV === 'production'
  ? config.build.assetsPublicPath
  : config.dev.assetsPublicPath

export default {
  name: 'App',
  /**
   * @see https://github.com/ktquez/vue-head
   */
  head: {
    link: [{
      rel: 'shortcut icon',
      href: `${subdirectory}static/images/favicon/favicon.ico`,
      type: 'icon'
    }],
    base: [{
      // wkhtmltopdfにbaseタグを伝えないと、CSSのlinkを解釈してくれない
      id: 'wkhtmltopdf-base',
      href: location.origin
    }]
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue